const env = process.env;
const baseURL = env.URL_ENV;
export default {
  baseURL
}



//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = null
// module chunks = 